export default {
  Count: 'Quantidade',
  'Count Unique Values': 'Quantidade de Valores Únicos',
  'List Unique Values': 'Lista de Valores Únicos',
  Sum: 'Soma',
  'Integer Sum': 'Soma Inteira',
  Average: 'Média',
  Median: 'Mediana',
  'Sample Variance': 'Variância',
  'Sample Standard Deviation': 'Desvio Padrão',
  Minimum: 'Mínimo',
  Maximum: 'Máximo',
  First: 'Primeiro',
  Last: 'Último',
  'Sum over Sum': 'Soma sobre soma',
  'Sum as Fraction of Total': 'Soma como Fração do Total',
  'Sum as Fraction of Rows': 'Soma como Fração de Linhas',
  'Sum as Fraction of Columns': 'Soma como Fração de Colunas',
  'Count as Fraction of Total': 'Quantidade como Fração do Total',
  'Count as Fraction of Rows': 'Quantidade como Fração de Linhas',
  'Count as Fraction of Columns': 'Quantidade como Fração de Colunas',
  All: 'Tudo',
  Select: 'Selecionar',
  Deselect: 'Desmarcar',
  'Filter values': 'Filtro',
  'Totals': 'Total',
};
